import React from 'react'
import { Header } from './Header'
import { Footer } from './Footer'

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-netflix-black flex flex-col">
      <Header />
      <main className="flex-1 pt-16"> {/* Account for fixed header */}
        {children}
      </main>
      <Footer />
    </div>
  )
}